<template>
  <el-dialog
    title="校验邮箱"
    v-model="visible"
    width="500px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p class="info">你的邮箱为：{{ email }},请输入该邮箱收到的验证码。</p>
    <el-form
      ref="ruleForm"
      :model="form"
      :rules="rules"
      label-width="95px"
      label-position="left"
      inline
    >
      <el-form-item label="邮箱验证码" prop="emailCode">
        <el-input
          v-model="form.emailCode"
          placeholder="请输入邮箱验证码"
          @input="changeMessage($event)"
        ></el-input>
        <el-button type="text" @click="reSendEmail" :disabled="timeNum != 0"
          >重发验证码<span v-if="timeNum != 0">({{ timeNum }})</span></el-button
        >
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" class="btn" @click="submit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CryptoJS from "crypto-js";
import { sendEmail, checkEmail } from "@/api/user";

export default {
  data() {
    return {
      visible: false,
      form: {},
      val: {},
      loginForm: {},
      email: "",
      rules: {
        emailCode: [
          { required: true, message: "请输入邮箱验证吗", trigger: "change" },
        ],
      },
      timer: "",
      timeNum: 0,
    };
  },

  methods: {
    async reSendEmail() {
      this.timeNum = 60;
        this.timer = setInterval(() => {
          this.timeNum--;
          if (this.timeNum == 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      const keyWord = "pigxpigxpigxpigx";
      const key = CryptoJS.enc.Utf8.parse(keyWord);
      // 加密
      var encrypted = CryptoJS.AES.encrypt(this.loginForm.password, key, {
        iv: key,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding,
      }).toString();
      const qureyform = {
        username: this.loginForm.username,
        password: encrypted,
      };
      const res = await sendEmail(qureyform);
      if (res.code == 0 ) {
        this.$message.success("邮箱验证吗已发送");
        this.email = res.data;
        
      } else {
        message.error(res.msg);
      }
    },
    changeMessage() {
      this.$forceUpdate();
    },
    open(loginForm, email, val) {
      console.log(loginForm, email, val);
      this.visible = true;
      this.email = email;
      this.loginForm = Object.assign({}, loginForm);
      this.val = Object.assign({}, val);
      this.form = Object.assign({}, {});
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
        this.timeNum = 60;
        this.timer = setInterval(() => {
          this.timeNum--;
          if (this.timeNum == 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.checkEmail();
      });
    },
    async checkEmail() {
      const keyWord = "pigxpigxpigxpigx";
      const key = CryptoJS.enc.Utf8.parse(keyWord);
      // 加密
      var encrypted = CryptoJS.AES.encrypt(this.loginForm.password, key, {
        iv: key,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding,
      }).toString();
      const qureyform = {
        username: this.loginForm.username,
        password: encrypted,
        emailCode: this.form.emailCode,
      };
      const { code } = await checkEmail(qureyform);
      if (code == 0) {
        this.$emit("changeSuc", this.val);
        this.visible = false;
      }else{
        this.$message.error('验证码输入错误')
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.btn {
  background-color: #276eff;
  color: #ffffff;
}
.info {
  color: #606266;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  padding-bottom: 5px;
}
::v-deep .el-input {
  width: calc(100% - 100px);
}

::v-deep .el-form-item {
  width: calc(100% - 0px);
}
::v-deep .el-form-item__content {
  width: calc(100% - 95px);
  display: flex;
  justify-content: space-between;
}
::v-deep .el-input__inner {
  left: 18px;
  font-weight: 500;
  font-size: 14px;
  background: rgb(243, 243, 243, 0.2);
  border: 0;
  height: 28px;
}
::v-deep .el-form-item--small .el-form-item__error {
  padding-left: 22px;
}
::v-deep .el-input--small .el-input__icon {
  line-height: 40px;
  font-size: 20px;
}
::v-deep .el-input--small .el-input__inner {
  height: 26px;
  line-height: 26px;
}
::v-deep .el-form-item__label {
  color: #606266;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
}
</style>